module.exports = __webpack_public_path__ + "media/aa_en_2.4125789f.mp4";